import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';
const queryString = require("query-string");
import ErrorContainer from '../portal/errorContainer';

@inject('oidcStore') @observer
export default class OidcError extends Component {

    componentDidMount() {

        let result = queryString.parse(window.location.hash);
        let errorId = result['/oidcerror?errorId'];
        this.props.oidcStore.getError(errorId);
    }

    render(){
        
        if(this.props.oidcStore.oidcError == null){
            
            return null;    
        }
            
        return (
        
            <ErrorContainer
                    error={this.props.oidcStore.oidcError.error}
                    errorDescription={this.props.oidcStore.oidcError.errorDescription}>
            </ErrorContainer>
        );
    }
}